import { Dispatch } from "redux";
import axiosInstance from "../base-url";
import { isLogin } from "./global-state-actions";
import { setAlert, setAlertContext, setAlertSeverity } from "./alerts-actions";

export const createActionType = (base: string) => ({
  REQUEST: `${base}_REQUEST`,
  SUCCESS: `${base}_SUCCESS`,
  FAILURE: `${base}_FAILURE`,
});

export const createAction = (type: string, payload?: any) => ({
  type,
  payload,
});

export const createAsyncAction = (
  actionType: any,
  url: string,
  method: "post" | "get" | "put" | "delete",
  data?: any,
  headers?: any
) => {
  return async (dispatch: Dispatch) => {
    dispatch(createAction(actionType.REQUEST));
    try {
      const response = await axiosInstance({
        method,
        url,
        data,
        headers,
      });
      const responseData = response.data;
      const responseStatus = response.status;

      dispatch(createAction(actionType.SUCCESS, responseData));
      return { data: responseData, status: responseStatus };
    } catch (error: any) {
      const status = error.response.status;
      const errorMsg = error.response.data.error;
      dispatch(createAction(actionType.FAILURE, errorMsg));
      if (status && status === 401) {
        if (status === 401) {
          dispatch(isLogin(false));
          dispatch(setAlert(true));
          dispatch(setAlertSeverity("warning"));
          dispatch(setAlertContext("توکن شما منقضی شد!"));
        }
      } else if (status !== 402) {
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("error"));
        dispatch(
          setAlertContext(
            `عملیات نا موفق! دوباره امتحان کنید ${error.response.data.error}`
          )
        );
      } else {
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("error"));
        dispatch(setAlertContext("لطفا دوباره امتحان کنید"));
      }

      throw error;
    }
  };
};
